import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import InputWidget from './InputWidget';
import _ from 'lodash';

/**
 * Stellt eine Einzelauswahl als Gruppe von Radio-Buttons dar.
 */
class RadioGroupControl extends InputWidget {

    /**
     * Prüft ob der übergebene Wert durch das onChange-event in den formik state existiert und dementsprechend
     * ob der radiobutton checked oder unchecked ist
     *
     * @param value
     * @return boolean
     */
    isChecked(value) {
        const radioValue = _.get(this.props.formikProps.values.widgets, this.props.widget.id);
        if (!radioValue) {
            return false;
        }
        return radioValue.toString() === value.toString();
    }

    render() {
        return (
            <Form.Group>
                <Form.Label>{this.renderLabelText()}</Form.Label>
                {this.props.options.map(({label, value}, index) => (
                    // Es muss der index als key genommen werden, da nicht garantiert ist,
                    // dass label oder value der choice eindeutig sind.
                    <Form.Check type="radio"
                                key={index}
                                id={`${this.getFieldName()}-${index}`}
                                name={`${this.getFieldName()}`}
                                label={label}
                                value={value}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                checked={this.isChecked(value)}
                                disabled={this.props.disabled}
                                data-testid={this.props.widget.id}
                    />
                ))}
                {/*
                    <Form.Control.Feedback> funktioniert nur bzgl. einer umgebenden <Form.Control> Komponente,
                    da wir aber die Fehlermeldung für die gesamte Gruppe an Checkboxen anzeigen wollen, müssen
                    wir diese Fehlermeldung selbst anzeigen.
                 */}
                {this.isInvalid() ? <small className="form-text text-danger">{this.getError()}</small> : null}
                {this.getCustomRequiredError()}
            </Form.Group>
        );
    }
}

RadioGroupControl.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
    }))
};

export default RadioGroupControl;
